<template>
  <section id="feedbacks-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="page-inner">
      <div class="content-panel">
        <feedbacks-title
          @get-feedbacks="getFeedbacks"
          @update-dates="updateDates"
          @update-store="updateStore"
          @download-feedbacks-report="downloadFeedbacksReport"
        />

        <h2 v-if="!fetched" class="empty-state">
          Selecione uma loja e clique em Buscar para ver os feedbacks.
        </h2>

        <template v-else>
          <h2 v-if="feedbacksReverse.length === 0" class="empty-state">
            Não existem feedbacks neste período para esta(s) loja(s).
          </h2>

          <template v-else>
            <div
              v-if="
                !permissions.canSeeUserPersonalId &&
                !permissions.canSeeUserEmail &&
                !permissions.canSeeUserCellphone
              "
              class="lgpd-notice"
            >
              Em concordância com a Lei 13.709 - Lei Geral de Proteção de Dados
              Pessoais (LGPD) - e em respeito à privacidade dos nossos usuários,
              não são exibidas aqui informações pessoais.
            </div>

            <div class="columns is-multiline">
              <feedback
                v-for="f in feedbacksReverse"
                :key="f._id"
                :feedback="f"
              />
            </div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import feedbacksTitle from "./FeedbacksTitle";
import feedback from "./Feedback";

export default {
  mixins: [common],

  components: {
    feedbacksTitle,
    feedback
  },

  data() {
    return {
      isLoading: false,
      fetched: false,
      dates: [],
      store: "",
      storeName: "Todas as lojas"
    };
  },

  computed: {
    ...mapGetters(["feedbacksReverse", "permissions"])
  },

  methods: {
    getFeedbacks() {
      this.isLoading = true;
      this.$store
        .dispatch("getFeedbacks", {
          storeId: this.store,
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
          this.fetched = true;
        });
    },

    updateDates(dates) {
      const fmt = d => {
        const date = d ? new Date(d) : new Date();
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      };
      this.dates = dates ? [fmt(dates[0]), fmt(dates[1])] : [fmt(), fmt()];
    },

    updateStore(payload) {
      this.store = payload ? payload.storeId : "";
      this.storeName = payload ? payload.storeName : "Todas as lojas";
    },

    downloadFeedbacksReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadFeedbacksReport", {
          storeName: this.storeName,
          storeId: this.store,
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.alertReportDowloadMessage();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    changeFeedbackStatus(data) {
      this.isLoading = true;
      this.$store
        .dispatch("changeFeedbackStatus", data)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$forceUpdate();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.updateDates();
  }
};
</script>

<style scoped>
#feedbacks-panel {
  min-height: 100vh;
  background-color: #f8f7fa;
  padding: 1.5rem;
}

.page-inner {
  width: 100%;
}

.content-panel {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #f3f4f6;
  padding: 1.5rem;
}

.empty-state {
  padding: 3rem 0;
  color: #9ca3af;
  text-align: center;
  font-size: 0.95rem;
}

.lgpd-notice {
  font-size: 0.8rem;
  color: #9ca3af;
  text-align: center;
  margin-bottom: 1rem;
}
</style>
